module.exports = __webpack_public_path__ + "static/img/11.a7267d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin_activity/11.png
// module id = e3gb
// module chunks = 0